import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveProjectExternalLinkRequestFailure() {
      return getState().isFailure;
    },
    isRemoveProjectExternalLinkRequestPending() {
      return getState().isPending;
    },
    isRemoveProjectExternalLinkRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
